// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3IJEr","choiceBoxes":"toolbarselects_choiceBoxes__1btZ1","simpleField":"toolbarselects_simpleField__3xcsP"};